/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Pensamos from "./Componentes/Home_Pensamos";
import Home_Manejamos from "./Componentes/Home_Manejamos";
import Home_Porcentajes from "./Componentes/Home_Porcentajes";
import Home_Calculadora from "./Componentes/Home_Calculadora";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import {SECCIONES} from "../../Constantes";

const Seccion_Home = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Home_Portada/>
            </Grid>

            <Grid id={SECCIONES[1]}  container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Pensamos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                <Home_Manejamos/>
            </Grid>

            <Grid id={SECCIONES[0]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Porcentajes/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Calculadora/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Testimonios/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Home